import { createContext } from "react";

export const SessionContext = createContext(null);